import React from "react";
import { useTable, List, EditButton, ShowButton, DeleteButton, CreateButton } from "@refinedev/antd";
import { Table, Space } from "antd";
import { VENDOR_LIST_QUERY, DELETE_VENDOR_MUTATION } from "./queries";
import { Vendor } from "./interface";

export const VendorList: React.FC = () => {
  const { tableProps } = useTable<Vendor>({
    resource: "vendors",
    initialPageSize: 10,
    meta: {
      gqlQuery: VENDOR_LIST_QUERY,
    },
  });

  return (
    <List
      headerProps={{
        extra: (
          <Space>
            <CreateButton />
          </Space>
        ),
      }}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="companyName" title="Company Name" sorter />
        <Table.Column
          dataIndex={["address", "city"]}
          title="City"
          sorter
        />
        <Table.Column
          dataIndex={["address", "country"]}
          title="Country"
          sorter
        />
        <Table.Column
          dataIndex={["contact", "name"]}
          title="Contact Name"
          sorter
        />
        <Table.Column<Vendor>
          title="Actions"
          dataIndex="actions"
          render={(_text: string, record: Vendor) => (
            <Space>
              <EditButton size="small" recordItemId={record.id} />
              <ShowButton size="small" recordItemId={record.id} />
              <DeleteButton size="small" recordItemId={record.id} meta={{ gqlMutation: DELETE_VENDOR_MUTATION}} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};